import * as React from 'react'

const DEBOUNCE_DELAY = 300

const useDebounce = <T>(val: T, delay = DEBOUNCE_DELAY) => {
  const [current, setCurrent] = React.useState(val)
  const [bounced, setBounced] = React.useState(val)

  React.useEffect(() => {
    const timer = setTimeout(() => setBounced(current), delay)
    return () => clearTimeout(timer)
  }, [current])

  return [current, bounced, setCurrent] as const
}

export default useDebounce
